import apiClient from "./client";
import binaryClient from "./binaryClient";
import ToastMessages from "../Shared/ToastMessages";

const getAll = async (endpoint, setData, dataField) => {
  if (typeof setData === "function" && typeof dataField === "string") {
    const response = await apiClient.get(endpoint);
    setData(response.data[dataField]);
    return response;
  }
  return await apiClient.get(endpoint);
};

const justGet = async (endpoint) => {
  return await apiClient.get(endpoint);
};

const show = async (endpoint, id) => {
  const response = await apiClient.get(endpoint + id);
  if (response.status !== 200) {
    ToastMessages.NotFound();
    return null;
  }
  return response.data;
};

const createNew = async (endpoint, data, setShowPayModal, noToast = false) => {
  const response = await apiClient.post(endpoint, data);
  if (response.status === 200) {
    if (!noToast) {
      ToastMessages.SuccessfulSave();
    }
  } else if (response.status === 403) {
  } else if (response.status === 402) {
    if(typeof setShowPayModal === "function")
    {
      setShowPayModal(true);
    }
  } else {
    if (!noToast) {
      ToastMessages.Error();
    }
  }
  return response;
};

const search = async (endpoint, data, noToast = false) => {
  return createNew(endpoint, data, null, noToast);
};

const edit = async (endpoint, data, noToast = false) => {
  const response = await apiClient.put(endpoint, data);
  if (!noToast) {
    if (response.status === 200) {
      ToastMessages.SuccessfulSave();
    } else {
      ToastMessages.Error();
    }
  }
  return response;
};

const del = async (endpoint, id) => {
  const response = await apiClient.delete(endpoint + id);
  if (response.status === 200) {
    ToastMessages.SuccessfulSave();
  } else {
    ToastMessages.Error();
  }
  return response;
};

const getBinary = (endpoint) => {
  return binaryClient.get(endpoint);
};

const getWithData = (endpoint, data) => {
  return binaryClient.put(endpoint, data);
};

export default {
  getAll,
  show,
  createNew,
  edit,
  del,
  getBinary,
  search,
  justGet,
  getWithData,
};
